
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'LoginStepBlowingItem',
    props: {
        count: {
            type: Number,
            default: 1,
        },
        isColorGray: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        isBorder: {
            type: Boolean,
            default: true,
        },
        isBlueBorder: {
            type: Boolean,
            default: false,
        },
    },
});
